
import { defineComponent } from 'vue';
import SingleLineAddress from './SingleLineAddress.vue';

export default defineComponent({
  components: {
    SingleLineAddress,
  },
  props: {
    layout: {
      type: String,
      default: 'horizontal',
    },
    target: {
      type: String,
    },
    platform: {
      type: String,
    },
    type: {
      type: String,
      default: 'map',
    },
    logo: {
      type: Boolean,
      default: false,
    },
    floatingButton: {
      type: String,
    },
    noFloatingButton: {
      type: Boolean,
    },
    mTracking: {
      type: String,
    },
  },
  computed: {
    defaultFloatingButtonLabel() {
      if (this.type === 'city' || this.type === 'external') {
        return this.platform === 'immowelt' ? 'Immowelt-Preisrechner' : 'Immonet-Preisrechner';
      }
      return 'Online-Preisrechner';
    },
  },
});
